import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols max-w-[1144px] max-w-176 w-full items-start self-stretch gap-4" }

import { ref, computed } from 'vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import ActionBar from '@/components/ActionBar/ActionBar.vue';
import { getFormInput } from '@/utils/form-input-helper';
import MembershipCardModal from '@/components/MembershipCard/MembershipCardModal.vue';
import { useSelfServicePhysicalMembershipCardStore } from '@/store';

enum AllActionButtons {
  btnViewCard = 'btnViewCard',
  btnAddToWallet = 'btnAddToWallet',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipCardHeader',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const membershipCardModalModalEl = ref<InstanceType<typeof MembershipCardModal>>();
const physicalCardStore = useSelfServicePhysicalMembershipCardStore();

const props = __props;

const platform = computed(() => {
  const ua = navigator.userAgent || navigator.vendor;
  const isAndroid = /android/i.test(ua);
  const isApple = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  return isAndroid ? 'android' : isApple ? 'apple' : 'unsupported';
});

const actionBarContent = getFormInput(props.content, 'actionBar');

const filteredFields = computed(() => {
  const validActionButtons = [AllActionButtons.btnViewCard];

  if (platform.value !== 'unsupported') {
    validActionButtons.push(AllActionButtons.btnAddToWallet);
  }

  const tempFilteredFields = {
    fields: actionBarContent.fields.filter((x: any) => validActionButtons.includes(x.name)),
  };

  return tempFilteredFields;
});

const onClick_ActionBarButton = async (linkItem: any) => {
  switch (linkItem.name) {
    case AllActionButtons.btnViewCard:
    case AllActionButtons.btnAddToWallet:
      if (!membershipCardModalModalEl?.value) return;
      membershipCardModalModalEl?.value.showModal();
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(FormStepInputs, {
        step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
      }, {
        actionBar: _withCtx(() => [
          (filteredFields.value)
            ? (_openBlock(), _createBlock(ActionBar, _mergeProps({ key: 0 }, filteredFields.value, {
                outerClass: _unref(actionBarContent).outerClass,
                innerClass: _unref(actionBarContent).innerClass,
                handleLinkClickEvent: true,
                onBtnClick: _cache[0] || (_cache[0] = (linkName) => onClick_ActionBarButton(linkName))
              }), null, 16, ["outerClass", "innerClass"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["step"])
    ]),
    _createVNode(MembershipCardModal, {
      ref_key: "membershipCardModalModalEl",
      ref: membershipCardModalModalEl,
      membershipCardModal: _unref(physicalCardStore).membershipCardModal
    }, null, 8, ["membershipCardModal"])
  ], 64))
}
}

})